export var Environments;
(function (Environments) {
    Environments["LOCAL"] = "LOCAL";
    Environments["DEV"] = "DEV";
    Environments["QA"] = "QA";
    Environments["STAGE"] = "STAGE";
    Environments["PROD"] = "PROD";
})(Environments || (Environments = {}));
export const getEnvironment = () => {
    const host = location.host.split('.');
    const localReg = /^localhost/g;
    const developmentReg = /-dev$/g;
    const qaReg = /-qa$/g;
    const stgReg = /-stg$/g;
    switch (true) {
        case localReg.test(host[0]):
            return Environments.LOCAL;
        case developmentReg.test(host[1]):
            return Environments.DEV;
        case qaReg.test(host[1]):
            return Environments.QA;
        case stgReg.test(host[1]):
            return Environments.STAGE;
        default:
            return Environments.PROD;
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isEnvironment = (testKey) => {
    if (Object.values(Environments).includes(testKey))
        return true;
    else {
        if (testKey)
            console.error('The Environment you tried to pass as apiEnv was not valid:', testKey);
        return false;
    }
};
export const getStaticAssetUrl = (environment) => {
    const env = environment || getEnvironment();
    switch (env) {
        case Environments.PROD:
            return 'https://www.info360.com';
        case Environments.QA:
            return 'https://app.info360-qa.com';
        case Environments.DEV:
        default:
            return 'https://app.info360-dev.com';
    }
};
